function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnvelope = function SvgEnvelope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_112",
    "data-name": "Group 112",
    transform: "translate(-197 -536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_94",
    "data-name": "Path 94",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.5c-2.633 0-5.186-.516-7.59-1.532-2.322-.982-4.408-2.388-6.199-4.18-1.79-1.79-3.197-3.876-4.179-6.198C1.016 25.186.5 22.633.5 20s.516-5.186 1.532-7.59c.982-2.322 2.388-4.408 4.18-6.199 1.79-1.79 3.876-3.197 6.198-4.179C14.814 1.016 17.367.5 20 .5s5.186.516 7.59 1.532c2.322.982 4.408 2.388 6.199 4.18 1.79 1.79 3.197 3.876 4.179 6.198C38.984 14.814 39.5 17.367 39.5 20s-.516 5.186-1.532 7.59c-.982 2.322-2.388 4.408-4.18 6.199-1.79 1.79-3.876 3.197-6.198 4.179C25.186 38.984 22.633 39.5 20 39.5z",
    style: {
      stroke: "none"
    },
    transform: "translate(197 536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1c-2.565 0-5.054.502-7.395 1.493-2.263.957-4.295 2.327-6.04 4.072s-3.115 3.777-4.072 6.04C1.503 14.946 1 17.435 1 20c0 2.565.502 5.054 1.493 7.395.957 2.263 2.327 4.295 4.072 6.04s3.777 3.115 6.04 4.072C14.946 38.497 17.435 39 20 39c2.565 0 5.054-.502 7.395-1.493 2.263-.957 4.295-2.327 6.04-4.072s3.115-3.777 4.072-6.04C38.497 25.054 39 22.565 39 20c0-2.565-.502-5.054-1.493-7.395-.957-2.263-2.327-4.295-4.072-6.04s-3.777-3.115-6.04-4.072C25.054 1.503 22.565 1 20 1m0-1c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0z",
    style: {
      fill: "#d5d5d6",
      stroke: "none"
    },
    transform: "translate(197 536)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_84",
    d: "M18.125 64H1.875A1.875 1.875 0 0 0 0 65.875v11.25A1.875 1.875 0 0 0 1.875 79h16.25A1.875 1.875 0 0 0 20 77.125v-11.25A1.875 1.875 0 0 0 18.125 64zm0 1.875v1.594c-.876.713-2.272 1.822-5.257 4.16-.658.517-1.961 1.761-2.868 1.746-.907.015-2.21-1.229-2.868-1.746-2.985-2.337-4.381-3.446-5.257-4.16v-1.594zm-16.25 11.25v-7.25c.9.713 2.164 1.713 4.1 3.228.854.672 2.349 2.156 4.026 2.147 1.669.009 3.145-1.453 4.026-2.146 1.935-1.515 3.2-2.516 4.1-3.229v7.25z",
    "data-name": "Path 84",
    transform: "translate(207 485)",
    style: {
      fill: "#264f73"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelope.14f336ee.svg";
export { ForwardRef as ReactComponent };